import React from 'react'
import PropTypes from 'prop-types'
import { BRAND_LIST, DESIGN_TEMPLATE_LIST } from '../../state/manage/const'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import LabelInput from '../../../form/component/LabelInput'
import Input from '../../../form/component/Input'
import Select from '../../../form/component/Select'
import TextArea from '../../../form/component/TextArea'
import ContentBox from '../../../layout/component/ContentBox'
import Checkbox from '../../../form/component/Checkbox'

const EmailTemplateVariant = ({ emailTemplateVariant, isEmailAdmin, changeEmailTemplateVariant, saveEmailTemplateVariant, testEmailTemplateVariant, deleteEmailTemplateVariant }) => {
    const localId = emailTemplateVariant.localId

    const _changeEmailTemplateVariant = isEmailAdmin ? (name, value) => {
        changeEmailTemplateVariant(localId, name, value)
    } : () => {
    }

    const _saveEmailTemplateVariant = isEmailAdmin ? () => {
        saveEmailTemplateVariant(localId)
    } : () => {

    }

    const _changeAndSaveEmailVariant = isEmailAdmin ? (name, value) => {
        changeEmailTemplateVariant(localId, name, value)
        saveEmailTemplateVariant(localId)
    } : () => {
    }


    return (
        <ContentBox title="Email Template Variant">
            <Row>
                <Column size={12}>
                    <button
                        onClick={() => {
                            testEmailTemplateVariant(localId)
                        }}
                        className="btn btn-primary btn-sm">
                        <i className="fa fa-send"/>&#160;test email
                    </button>
                    &#160;
                    {isEmailAdmin && (
                        <button
                            onClick={() => {
                                deleteEmailTemplateVariant(localId)
                            }}
                            className="btn btn-danger btn-sm">
                            <i className="fa fa-trash-o"/>&#160;delete
                        </button>
                    )}
                </Column>
            </Row>
            <Row top="M">
                <Column size={4}>
                    <LabelInput label="Variant Name">
                        <Input
                            object={emailTemplateVariant}
                            readOnly={!isEmailAdmin}
                            name="variant"
                            onChange={_changeEmailTemplateVariant}
                            onBlur={_saveEmailTemplateVariant}/>
                    </LabelInput>
                </Column>
                <Column size={4}>
                    <LabelInput label="Probability">
                        <Input
                            object={emailTemplateVariant}
                            readOnly={!isEmailAdmin}
                            name="probability"
                            type="number"
                            onChange={_changeEmailTemplateVariant}
                            onBlur={_saveEmailTemplateVariant}/>

                    </LabelInput>
                </Column>
                <Column size={4}>
                    <br/>
                    <Checkbox
                        object={emailTemplateVariant}
                        name="active"
                        readOnly={!isEmailAdmin}
                        onChange={_changeAndSaveEmailVariant}>
                        Active
                    </Checkbox>

                </Column>
            </Row>
            <Row top="M">
                <Column size={4}>
                    <LabelInput label="Subject">
                        <Input
                            object={emailTemplateVariant}
                            readOnly={!isEmailAdmin}
                            name="subject"
                            onChange={_changeEmailTemplateVariant}
                            onBlur={_saveEmailTemplateVariant}/>
                    </LabelInput>
                </Column>
                <Column size={4}>
                    <LabelInput label="Design Template">
                        <Select
                            object={emailTemplateVariant}
                            readOnly={!isEmailAdmin}
                            name="designTemplateId"
                            onChange={_changeAndSaveEmailVariant}
                            valueList={DESIGN_TEMPLATE_LIST}/>

                    </LabelInput>
                </Column>
                <Column size={4}>
                    <LabelInput label="Brand">
                        <Select
                            object={emailTemplateVariant}
                            readOnly={!isEmailAdmin}
                            name="brand"
                            onChange={_changeAndSaveEmailVariant}
                            valueList={BRAND_LIST}/>

                    </LabelInput>
                </Column>
            </Row>
            <Row>
                <Column size={12}>
                    <LabelInput label="Email Text">
                        <TextArea
                            name="emailText"
                            className="email-text-edit"
                            object={emailTemplateVariant}
                            readOnly={!isEmailAdmin}
                            onChange={_changeEmailTemplateVariant}
                            onBlur={_saveEmailTemplateVariant}/>
                    </LabelInput>
                </Column>
            </Row>
            <Row top="M">
                <Column size={12}>
                    <LabelInput label="SMS Text">
                        <TextArea
                            name="smsText"
                            className="sms-text-edit"
                            object={emailTemplateVariant}
                            readOnly={!isEmailAdmin}
                            onChange={_changeEmailTemplateVariant}
                            onBlur={_saveEmailTemplateVariant}/>
                    </LabelInput>
                    <LabelInput label={' ' + (emailTemplateVariant.smsText ? emailTemplateVariant.smsText.length : 0) + ' character. Max length after macro expansion 765'}/>
                </Column>
            </Row>
        </ContentBox>
    )
}


EmailTemplateVariant.propTypes = {
    emailTemplateVariant: PropTypes.object.isRequired,
    isEmailAdmin: PropTypes.bool.isRequired,

    changeEmailTemplateVariant: PropTypes.func.isRequired,
    saveEmailTemplateVariant: PropTypes.func.isRequired,
    testEmailTemplateVariant: PropTypes.func.isRequired,
    deleteEmailTemplateVariant: PropTypes.func.isRequired,
}


export default EmailTemplateVariant




// WEBPACK FOOTER //
// ./src/modules/email/component/manage/EmailTemplateVariant.js